var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
const ButtonPartial = styled.button `
  font-family: 'Nunito Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 700;
  border: 0;
  border-radius: 3em;
  cursor: pointer;
  display: inline-block;
  line-height: 1;
  ${(props) => props.primary
    ? css `
          color: white;
          background-color: ${props.backgroundColor ? props.backgroundColor : '#1ea7fd'};
        `
    : css `
          color: #333;
          background-color: ${props.backgroundColor ? props.backgroundColor : 'transparent'};
          box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 0px 1px inset;
        `}
  font-size: ${(props) => {
    switch (props.size) {
        case 'small':
            return '12px';
        case 'medium':
            return '14px';
        case 'large':
            return '16px';
        default:
            return '14px';
    }
}};
  padding: ${(props) => {
    switch (props.size) {
        case 'small':
            return '10px 16px';
        case 'medium':
            return '11px 20px';
        case 'large':
            return '12px 24px';
        default:
            return '11px 20px';
    }
}};
`;
/**
 * Primary UI component for user interaction
 */
const Button = (_a) => {
    var { primary = false, size = 'medium', children, backgroundColor, onClick, onMouseEnter, onMouseLeave, onFocus, onBlur } = _a, props = __rest(_a, ["primary", "size", "children", "backgroundColor", "onClick", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"]);
    return (React.createElement(ButtonPartial, Object.assign({ onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur, type: "button", primary: primary, size: size, onClick: onClick, backgroundColor: backgroundColor }, props), children));
};
export default Button;
